import React, { useContext, useEffect } from "react";
import styles from "./Footer.module.css";
import { SocialContext } from "../../context/SocialContext";
const Footer = () => {
  const { link, getSocialLink } = useContext(SocialContext);
  const { sociallink } = link;
  useEffect(() => {
    getSocialLink();
  }, [getSocialLink]);

  return (
    <div className={"pt-5 " + styles.footer_container}>
      <div className="container">
        <div className="row">
          <div className="col-12  col-md-6  ">
            <div className={`mx-auto mw-100 ${styles.contact_wrap}`}>
              <h2>Contact Us</h2>

              <p className={`d-inline-block  ${styles.address}`}>
                <i
                  className={`fa fa-map-marker fa-w-16  ${styles.address_icon}`}
                ></i>
                <span className="d-inline-block">
                  R. Joao Crisostomo De Sa <br /> N10-2745-027
                </span>
              </p>
              <br />
              <a
                href="tel:+655 933 073 523"
                className={`d-inline-block mt-3 ${styles.telephone}`}
              >
                <i className={`fa fa-phone ${styles.phone_icon}`}></i>
                +351 933 073 523
              </a>
              <br />
              <a
                href="mailto:mahfuz477gmail.com"
                className={`d-inline-block mt-3 ${styles.email}`}
              >
                <i className={`fa fa-envelope ${styles.email_icon}`}></i>
                cs/k@gmail.co
              </a>
            </div>
          </div>

          <div className="col-12 col-md-6   mt-3 mt-md-0 ">
            <div className={`d-block mx-auto  mx-100  ${styles.timeSchedule}`}>
              <h2>Opening Hours</h2>
              <ul className="nav d-block">
                <li className="nav-item">
                  <span>Mon : </span> 10:30 am - 10:30 pm
                </li>
                <li className="nav-item">
                  <span>Tue : </span> 10:30 am - 10:30 pm
                </li>
                <li className="nav-item">
                  <span>Wed : </span> 10:30 am - 10:30 pm
                </li>
                <li className="nav-item">
                  <span>Thu : </span> 10:30 am - 10:30 pm
                </li>
                <li className="nav-item">
                  <span>Fri : </span> 10:30 am - 10:30 pm
                </li>
                <li className="nav-item">
                  <span>Sat :</span> 10:30 am - 10:30 pm
                </li>
                <li className="nav-item">
                  <span>Sun : </span> 10:30 am - 10:30 pm
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-12 ">
            <div className={`text-center py-4 ${styles.social_link} `}>
              <ul className="nav justify-content-center">
                <li className="nav-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      sociallink
                        ? "https://" + sociallink[0].facebook
                        : "https://#"
                    }
                    className="nav-link"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      sociallink
                        ? "https://" + sociallink[0].twitter
                        : "https://#"
                    }
                    className="nav-link"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={
                      sociallink
                        ? "https://" + sociallink[0].instagram
                        : "https://#"
                    }
                    className="nav-link"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    target="_blank"
                    href={
                      sociallink
                        ? "https://" + sociallink[0].tumblr
                        : "https://#"
                    }
                    className="nav-link"
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-tumblr"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p className={" py-2 text-center " + styles.copyright}>
        Copyright All right Resarved 2020
      </p>
    </div>
  );
};

export default Footer;
